import { colorConstants } from 'config/colorConstants';

const User = ({
    color = colorConstants.violet,
    className = '',
    size = 12,
}: {
    color?: string;
    className?: string;
    size?: number;
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.00004 2C5.03354 2 4.25004 2.7835 4.25004 3.75C4.25004 4.7165 5.03354 5.5 6.00004 5.5C6.96654 5.5 7.75004 4.7165 7.75004 3.75C7.75004 2.7835 6.96654 2 6.00004 2ZM3.25004 3.75C3.25004 2.23122 4.48126 1 6.00004 1C7.51882 1 8.75004 2.23122 8.75004 3.75C8.75004 5.26878 7.51882 6.5 6.00004 6.5C4.48126 6.5 3.25004 5.26878 3.25004 3.75ZM4.66317 7.24998C4.69171 7.24999 4.72066 7.25 4.75004 7.25H7.25004C7.27943 7.25 7.30838 7.24999 7.33691 7.24998C7.95054 7.24975 8.36955 7.24959 8.72576 7.35765C9.52476 7.60002 10.15 8.22528 10.3924 9.02428C10.5004 9.38049 10.5003 9.79949 10.5001 10.4131C10.5001 10.4417 10.5 10.4706 10.5 10.5C10.5 10.7761 10.2762 11 10 11C9.7239 11 9.50004 10.7761 9.50004 10.5C9.50004 9.76584 9.49461 9.5096 9.43545 9.31457C9.29003 8.83517 8.91487 8.46001 8.43547 8.31459C8.24044 8.25542 7.9842 8.25 7.25004 8.25H4.75004C4.01588 8.25 3.75965 8.25542 3.56461 8.31459C3.08521 8.46001 2.71006 8.83517 2.56463 9.31457C2.50547 9.5096 2.50004 9.76584 2.50004 10.5C2.50004 10.7761 2.27618 11 2.00004 11C1.7239 11 1.50004 10.7761 1.50004 10.5C1.50004 10.4706 1.50003 10.4417 1.50002 10.4131C1.49979 9.7995 1.49964 9.38049 1.60769 9.02428C1.85007 8.22528 2.47533 7.60002 3.27433 7.35765C3.63053 7.24959 4.04954 7.24975 4.66317 7.24998Z"
            fill={color}
        />
    </svg>
);

export default User;
